import { z } from '@betty/toolkit/api';

export const PaymentProviderSchema = z
  .enum(['Nuvei', 'Gigadat', 'WorldpayApplePay'])
  .or(z.string());

export const PaymentProvidersSchema = z.object({
  deposits: z.array(PaymentProviderSchema),
  withdrawals: z.array(PaymentProviderSchema),
});

export const PaymentDetailsSchema = z.object({
  email: z.string(),
  phoneNumber: z.string(),
});

export const PaymentUrlSchema = z.object({
  url: z.string(),
});

export const TransactionStatusSchema = z.object({
  amount: z.number(),
  paymentEntityId: z.number(),
  transactionType: z.enum(['Deposit', 'Withdrawal']),
  status: z.enum([
    'Approved',
    'Declined',
    'Pending',
    'InProgress',
    'Failed',
    'Canceled',
    'Started',
  ]),
  messageCode: z
    .enum([
      'try-again',
      'try-again-later',
      'contact-support',
      'check-your-expiry-date',
      'incorrect-card-details',
      'incorrect-card-number',
      'incorrect-cvv',
      'check-your-card-balance-and-try-again',
      'another-card-or-payment-method',
      'try-again-or-use-another-payment-method',
      'transaction-was-unsuccessful-due-to-insufficient-funds',
      'exceeded-the-limit-of-250-cad',
      'reached-the-daily-deposit-limit',
      'deposit-with-interac',
      'try-with-less-amount',
      'use-another-payment-method-with-deposits',
      'additional-payment-method-verification-required',
      'payment-method-document-pending-review',
    ])
    .optional(),
});

export const CardVendorSchema = z.enum(['Visa', 'Mastercard']);

export const UnverifiedPaymentMethodSchema = z.object({
  cardVendor: CardVendorSchema,
  expiryDate: z.string(),
  lastUse: z.string(),
  paymentEntityId: z.number(),
  uniqueIdentifier: z.string(),
});

export const UnverifiedPaymentMethodsSchema = z.array(
  UnverifiedPaymentMethodSchema,
);

export const CheckInteracEmailStatusSchema = z.enum([
  'Verified',
  'Unverified',
  'Blocked',
  'Available',
]);

export const CheckInteracEmailSchema = z.object({
  status: CheckInteracEmailStatusSchema,
});

export const SendInteracEmailSchema = z.object({}).optional();

export const ResendInteracEmailSchema = z.object({}).optional();

export const VerifyInteracEmailResultSchema = z.enum([
  'Verified',
  'Expired',
  'Error',
]);

export const VerifyInteracEmailSchema = z.object({
  playerId: z.number(),
  email: z.string(),
  result: VerifyInteracEmailResultSchema,
});

export const WithdrawalLimitsSchema = z.object({
  minAmount: z.number(),
  providerMaxAmount: z.object({
    Gigadat: z.number().nullable(),
    Nuvei: z.number().nullable(),
  }),
});

export type WithdrawalLimits = z.infer<typeof WithdrawalLimitsSchema>;

export const ApplePayDepositResponseSchema = z.object({
  transactionId: z.number(),
  status: z
    .enum(['Approved', 'Declined', 'Pending', 'Success', 'Error', 'Fail'])
    .or(z.string()),
});
